import type { DataAttributes } from 'shared/lib/data-auto-test';

import { useGetZipDraft } from '../api';

import { ZipResultsItem } from './ZipResultsItem';

interface ZipResultsCampaignProps extends DataAttributes {
  className?: string;
  type: 'valid' | 'duplicate' | 'invalid';
  titleCounter?: number;
  resultType?: 'create' | 'campaign' | 'groups';
  campaignId: number;
  onlyInvalid?: boolean;
}

export function ZipResultsCampaign({
  className,
  type,
  titleCounter,
  resultType,
  campaignId,
  onlyInvalid,
  attributes,
}: ZipResultsCampaignProps) {
  const { data, refetch, isFetching } = useGetZipDraft(campaignId, type);

  return (
    <ZipResultsItem
      attributes={attributes}
      className={className}
      type={type}
      titleCounter={titleCounter}
      resultType={resultType}
      body={data?.data.zipCodes}
      refetch={refetch}
      isFetching={isFetching}
      onlyInvalid={onlyInvalid}
    />
  );
}
